import Alertify from 'alertify.js'
// import scriptjs from 'scriptjs'
import dateFormat from "dateformat";
import Cookies from 'js-cookie'
let ElementUi = require('element-ui')
const utils = {
    vm: null,
    authInit(vm) {
        this.vm = vm;
        return new Promise((resolve, reject) => {
            const token = Cookies.get('token');
            if (token) {
                // const permission =JSON.parse(Cookies.get('permission'));
                vm.$store.commit('TOKEN_INIT', { 'token': token });
                vm.$store.dispatch('fetchProjectList');
                vm.$store.dispatch("fetchCityList");
                vm.$store.dispatch('fetchSupportCityList');
            }
            resolve()
        })
    },
    'initEndTime': function(time) { //结束时间修改为当前时间23：59：59DELETEDELETE
        if (time) return time + 24 * 60 * 60 * 1000 - 1000
    },
    loginRedirect(cb, redirect = true) {
        if (this.$store.state.auth.token !== '') {
            cb()
        } else {
            const str = redirect ? ('?returnUrl=' + this.$route.path) : '';
            this.$router.push('/login' + str);
        }
    },
    setCookie(key, value) {
        Cookies.set(key, value)
    },
    getCookie(name) {
        return Cookies.get(name)
    },
    autoSizeImage(w, h, slim = false) {
        // return `?imageMogr2/thumbnail/${w}x${h}/blur/1x0/quality/100${slim ? '|imageslim': ''}`
        return `?imageMogr2/auto-orient/thumbnail/!${w}x${h}r/gravity/Center/crop/${w}x${h}/blur/1x0/quality/100${slim ? '|imageslim' : ''}`
    },
    avatar(url, w, h) {
        return url + utils.autoSizeImage(w, h)
    },
    scrollTop() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    },
    'alert': function() {
        Alertify.alert(...arguments)
    },
    'log': function() {
        Alertify.log(...arguments)
    },
    'confirm': function() {
        Alertify.confirm(...arguments)
    },
    'error': function() {
        Alertify.error(...arguments)
    },
    //定义一个加法函数
    'add': function(num1, num2) {
        var baseNum, baseNum1, baseNum2;
        var precision; // 精度
        try {
            baseNum1 = num1.toString().split(".")[1].length;
        } catch (e) {
            baseNum1 = 0;
        }
        try {
            baseNum2 = num2.toString().split(".")[1].length;
        } catch (e) {
            baseNum2 = 0;
        }
        baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
        precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
        return ((num1 * baseNum + num2 * baseNum) / baseNum).toFixed(precision);
    },
    'checkResponse': function(res, showError = true) {
        // const err_msg = this.retrieve_err_msg(data)
        // let data=JSON.parse(res.data);
        // if (data.subMessage && showError) {
        //   	this.alert(data.subMessage)
        // }
        if (0 === res.data.code || 200 === res.data.code) {
            return res.data;
        } else if (103000 === res.data.code) { //未登录 或者登录超时
            // 清空本地token跳转到登录页面
            // window.open('/auth/login');
            var arr = window.location.href.split('?');
			ElementUi.Message.closeAll();
			ElementUi.Message.error(res.data.msg);
			if (arr[1]) {
				this.vm.$router.push('/auth/login?' + arr[1]);
			} else {
				this.vm.$router.push('/auth/login');
			}
			Cookies.remove('token');
			return false
        } else {
            this.alert(res.data.msg);
            return false
        }
    },
    'retrieve_err_msg': function(data) {
        if ('object' === typeof data && 'string' === typeof data.err_msg && data.err_msg.length > 0) {
            return data.err_msg
        }
    },
    'formatDate': function(date) {
        return dateFormat(date, "yyyy-mm-dd");
    },
    'formatDateToSecond': function(date) {
        if (date) {
            return dateFormat(date, "yyyy-mm-dd  HH:MM:ss");
        } else {
            return
        }
    },
    'form': function(date) {
        if (date) {
            return (new Date(date)).getTime();
        } else {
            return
        }
    },
    'delRepeat': function(arr) {
        var obj = {};
        arr = arr.reduce((cur, next) => {
            obj[next.orderNo] ? "" : obj[next.orderNo] = true && cur.push(next);
            return cur;
        }, [])
        return arr;
    },
    // 浮点数求和
	add(a, b) {
		let c, d, e;
		try {
			c = a.toString().split(".")[1].length;
		} catch (f) {
			c = 0;
		}
		try {
			d = b.toString().split(".")[1].length;
		} catch (f) {
			d = 0;
		}
		return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) + this.mul(b, e)) / e;
	},
	// 浮点数相减
	sub(a, b) {
		let c, d, e;
		try {
			c = a.toString().split(".")[1].length;
		} catch (f) {
			c = 0;
		}
		try {
			d = b.toString().split(".")[1].length;
		} catch (f) {
			d = 0;
		}
		return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) - this.mul(b, e)) / e;
	},
	// 浮点数相乘
	mul(a, b) {
		let c = 0,
		d = a.toString(),
		e = b.toString();
		try {
			c += d.split(".")[1].length;
		} catch (f) {
		}
		try {
			c += e.split(".")[1].length;
		} catch (f) {
		}
		return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
	},
	// 浮点数相除
	div(a, b) {
		let c, d, e = 0,
		f = 0;
		try {
			e = a.toString().split(".")[1].length;
		} catch (g) {
		}
		try {
			f = b.toString().split(".")[1].length;
		} catch (g) {
		}
		return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), this.mul(c / d, Math.pow(10, f - e));
	},
	reTofixed(num, fractionDigits) {
		return (Math.round(num * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits) + Math.pow(10, -(fractionDigits + 1))).toString().slice(0, -1)
	},
}

export default utils


// WEBPACK FOOTER //
// ./src/utils.js